import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-10"
}
const _hoisted_2 = { class: "bg-background w-full min-h-screen p-4" }
const _hoisted_3 = {
  key: 0,
  class: "bg-white w-full rounded-2xl shadow-xl px-8 py-4 justify-between container items-start h-full"
}
const _hoisted_4 = { class: "pt-4" }
const _hoisted_5 = { class: "flex flex-row items-center" }
const _hoisted_6 = { class: "flex justify-center items-center rounded-full bg-primary text-white text-4xl w-24 h-24 p-4" }
const _hoisted_7 = { class: "block px-4 space-y-1 w-full" }
const _hoisted_8 = { class: "block text-2xl font-bold" }
const _hoisted_9 = { class: "block text-lg text-gray-400" }
const _hoisted_10 = { class: "space-y-3 p-3 w-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "block text-2xl font-bold pt-4" }, "Candidate Profile", -1)
const _hoisted_12 = {
  key: 0,
  class: "block text-base font-bold"
}
const _hoisted_13 = { class: "text-xs opacity-30" }
const _hoisted_14 = { class: "text-xs tracking-wide" }
const _hoisted_15 = {
  key: 1,
  class: "flex flex-row items-center py-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "block text-base font-bold"
}
const _hoisted_19 = { class: "text-xs opacity-30" }
const _hoisted_20 = { class: "text-xs tracking-wide truncate w-10/12" }
const _hoisted_21 = {
  key: 3,
  class: "flex flex-row items-center py-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 4,
  class: "block text-base font-bold"
}
const _hoisted_25 = {
  key: 5,
  class: "block text-sm font-extralight w-full overflow-ellipsis text-justify"
}
const _hoisted_26 = {
  key: 6,
  class: "block text-base font-bold"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "block text-base font-bold" }, "Contact details", -1)
const _hoisted_28 = { class: "flex flex-row w-full space-x-5 items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Address", -1)
const _hoisted_30 = { class: "text-sm font-extralight" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_32 = { class: "flex flex-row w-full space-x-8 items-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Phone", -1)
const _hoisted_34 = { class: "text-sm font-extralight" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_36 = { class: "flex flex-row w-full space-x-8 items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Email", -1)
const _hoisted_38 = { class: "text-sm font-extralight" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Chips = _resolveComponent("Chips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loading, {
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            opacity: 1,
            "is-full-page": true
          }, null, 8, ["active"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isLoading && _ctx.candidate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getInitials(`${_ctx.candidate?.first_name} ${_ctx.candidate?.last_name}`)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(`${_ctx.candidate?.first_name} ${_ctx.candidate?.last_name}`), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.candidate?.position), 1),
                  _withDirectives(_createElementVNode("span", { class: "block text-lg text-gray-400" }, _toDisplayString(`Salary expectation: ${_ctx.numberWithCommas(
                  parseInt(_ctx.candidate.salary_expectation, 10)
                )} ${_ctx.candidate.salary_currency || ""}`), 513), [
                    [_vShow, _ctx.candidate && _ctx.candidate.salary_expectation]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (
            _ctx.candidate &&
            _ctx.candidate.candidate_work_histories &&
            _ctx.candidate.candidate_work_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Work experience "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidate.candidate_work_histories, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-work-${index + 1}`,
                  class: "flex flex-row items-center space-x-2"
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(`${new Date(item.start_date).getFullYear()} - ${_ctx.buildNow(
              new Date(item.end_date).getFullYear(),
              item.is_current
            )}`), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(`${item.job_title} at ${
                item.company_name ? item.company_name : " Not specified"
              }`), 1)
                ]))
              }), 128)),
              (
            _ctx.candidate &&
            _ctx.candidate.candidate_work_histories &&
            _ctx.candidate.candidate_work_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true),
              (
            _ctx.candidate &&
            _ctx.candidate.candidate_education_histories &&
            _ctx.candidate.candidate_education_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Education "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidate.candidate_education_histories, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-work-${index + 1}`,
                  class: "flex flex-row items-center space-x-2"
                }, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(`${new Date(item.start_date).getFullYear()} - ${_ctx.buildNow(
              new Date(item.end_date).getFullYear(),
              item.is_current
            )}`), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(`${item.degree} at ${item.learning_center}`), 1)
                ]))
              }), 128)),
              (
            _ctx.candidate &&
            _ctx.candidate.candidate_education_histories &&
            _ctx.candidate.candidate_education_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                : _createCommentVNode("", true),
              (_ctx.candidate && _ctx.candidate?.summary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Summary "))
                : _createCommentVNode("", true),
              (_ctx.candidate && _ctx.candidate?.summary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.candidate?.summary), 1))
                : _createCommentVNode("", true),
              (_ctx.candidate && _ctx.candidate.skills && _ctx.candidate.skills.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Skills "))
                : _createCommentVNode("", true),
              (_ctx.candidate && _ctx.candidate.skills.length > 0)
                ? (_openBlock(), _createBlock(_component_Chips, {
                    key: 7,
                    chips: _ctx.candidate.skills,
                    isInput: false
                  }, null, 8, ["chips"]))
                : _createCommentVNode("", true),
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.candidate?.address ? _ctx.candidate?.address : "NA"), 1)
              ]),
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.candidate?.phone), 1)
              ]),
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.candidate?.email), 1)
              ]),
              _hoisted_39
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}